import {
  BreakConfigurationsDataTableDocument,
  GetBreakConfigurationsDocument,
  UpdateBreakConfigurationDocument,
  UpdateBreakConfigurationMutation,
  UpdateBreakConfigurationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateBreakConfiguration = () => {
  const [updateBreakConfiguration, { loading }] = useMutation(UpdateBreakConfigurationDocument, {
    extractorFn: (data: UpdateBreakConfigurationMutation) =>
      data.timeSettingsMutations.updateTimesettingsBreakConfiguration,
  })
  return {
    loading,
    update(variables: UpdateBreakConfigurationMutationVariables) {
      return updateBreakConfiguration({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          { query: BreakConfigurationsDataTableDocument },
          { query: GetBreakConfigurationsDocument },
        ],
      })
    },
  }
}
